<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon icon-style">
                <md-icon>inventory</md-icon>
                Services
            </div>
        </md-card-header>
        <md-card-content>
            <p v-if="!services || services.length === 0" class="grayedout-text text-center">
                No services found
            </p>
            <div v-else>
                <div class="service-table-container" :class="{ 'with-scroll': enableScroll }">
                    <md-table class="context-menu-support custom-paginated-table">
                        <md-table-row>
                            <md-table-head>Service</md-table-head>
                            <md-table-head>Description</md-table-head>
                            <md-table-head>Quantity</md-table-head>
                            <md-table-head>Actions</md-table-head>
                        </md-table-row>
                        <md-table-row v-for="service in services" :key="service.serviceId">
                            <md-table-cell>{{ service.name }}</md-table-cell>
                            <md-table-cell>{{ service.description }}</md-table-cell>
                            <md-table-cell class="quantity-column">
                                {{ service.quantity }}
                                <span class="quantity-type">{{ service.quantityType }}</span>
                            </md-table-cell>
                            <md-table-cell v-if="$root.isDesktop && !isReadOnlyUser" class="actions-column">
                                <div class="action-button">
                                    <md-button
                                        v-if="!isReadOnlyUser"
                                        title="Delete service"
                                        class="md-danger md-just-icon md-round"
                                        :disabled="isInvoiced"
                                        @click.stop="handleDeleteService(service.serviceId)"
                                    >
                                        <md-icon>delete</md-icon>
                                    </md-button>
                                    <md-tooltip v-if="isInvoiced" class="line-tooltip" md-direction="top">
                                        You cannot delete a service when the run is invoiced.
                                    </md-tooltip>
                                </div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table>
                </div>
            </div>
        </md-card-content>
        <md-card-actions v-if="($root.isDesktop && !isReadOnlyUser) || isInvoiced">
            <md-button class="md-success" @click="handleAddService()">
                Add Service
            </md-button>
        </md-card-actions>
    </md-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { GeneralMixin } from '@/mixins';
import { handleRequests, showErrorMessage } from '@/helpers';
import RunServiceLineModal from '../Modals/RunServiceLineModal';

export default {
    name: 'RunServices',
    mixins: [GeneralMixin],
    props: {
        services: {
            type: Array,
            default: () => []
        },
        isInvoiced: {
            type: Boolean,
            default: false
        },
        runId: {
            type: Number,
            default: null
        }
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isReadOnlyUser: 'user/isReadOnlyUser'
        }),
        enableScroll() {
            return this.services.length > 5;
        }
    },
    methods: {
        handleAddService() {
            this.$modal
                .show(RunServiceLineModal, {
                    runId: this.runId,
                    lines: this.services
                })
                .then(() => {
                    this.$emit('serviceUpdated');
                    this.$modal.hide();
                });
        },
        async handleConfirmDelete(serviceId) {
            this.$_handleLoaderState(true, 'UPDATING...');
            if (this.runId === null || this.runId === undefined) {
                showErrorMessage(this, 'Run does not exist.');
                this.$_handleLoaderState(false);
                return;
            }

            try {
                await handleRequests(`/api/runs/${this.runId}/lines/${serviceId}`, { method: 'delete' });
                this.$emit('serviceUpdated');
                this.$notify({ message: 'Service deleted!', type: 'success' });
            } catch (e) {
                showErrorMessage(this, 'Cannot delete service.');
            } finally {
                this.$_handleLoaderState(false);
            }
        },
        async handleDeleteService(serviceId) {
            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Service',
                    body: 'Are you sure you want to delete this service?',
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm')
                        await this.handleConfirmDelete(serviceId);
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.service-table-container {
    max-height: 600px;
}

.service-table-container.with-scroll {
    overflow-y: scroll;
}

.actions-column {
    width: 100px;
}

.icon-style {
    color: white;
}
</style>
